import { Input, TextArea } from "@portal/BaseComponents/Input/AntInput";
import { Select } from "@portal/BaseComponents/Select/AntSelect";
import {
  MaxTagRenderer,
  TagRendererParams,
  onSelectChange,
} from "@portal/BaseComponents/Select/type";
import { SkeletonInput } from "@portal/BaseComponents/Skeleton/AntSkeleton";
import { StyledTag } from "@portal/BaseComponents/Tag/style";
import { Icon } from "@portal/lib/icons/icons";
import { useDisputeTypesQuery } from "@portal/queries/dispute-query";

import {
  OnInputChange,
  OnTextAreaChange,
} from "@portal/BaseComponents/Input/type";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { useMemo, useState } from "react";
import { mapDisputeTypesOptionPredicate } from "./predicte";
import { DisputeDefaultFormElementProps } from "./type";
const CloseIcon = <Icon color="var(--gray-7)" icon={["fal", "times"]} />;

function DisputeTypesForm(
  props: DisputeDefaultFormElementProps<string[], string[]>
) {
  const { value: defaultValues, onChange } = props;
  const { data: disputeTypes, isLoading } = useDisputeTypesQuery();
  const [selectedValues, setSelectedValues] = useState<string[] | undefined>(
    defaultValues
  );

  function getDisputeTypes() {
    if (!disputeTypes) return [];
    return disputeTypes.list.map(mapDisputeTypesOptionPredicate);
  }

  function maxTagRenderer(props: MaxTagRenderer<string[]>[0]) {
    const omittedValues = props.map((value) => value.label).join(", ");
    return (
      <ToolTip placement="bottomLeft" title={omittedValues} zIndex={4000}>
        <TypographyText fs={"12"}>{`+${props.length}`}</TypographyText>
      </ToolTip>
    );
  }
  function customTagRender(props: TagRendererParams<string[]>[number]) {
    const { label, onClose, closable } = props;

    return (
      <StyledTag
        closeIcon={CloseIcon}
        onClose={onClose}
        closable={closable}
        style={{ lineHeight: "1.5" }}
      >
        <TypographyText
          ellipsis={{ tooltip: true }}
          style={{ maxWidth: "120px" }}
        >
          {label}
        </TypographyText>
      </StyledTag>
    );
  }
  const options = useMemo(getDisputeTypes, [disputeTypes]);

  function handleChange(...args: onSelectChange<string[]>) {
    const [value] = args;

    setSelectedValues(value);
    onChange?.(value);
  }
  // function handleFilterOptions() {
  //   const filterOptionPredicate = (value: any) => {
  //     return !selectedValues?.includes(value.value);
  //   };
  //   return filter(options, filterOptionPredicate);
  // }

  // const filterOptions = useMemo(handleFilterOptions, [options, selectedValues]);

  return isLoading ? (
    <SkeletonInput active style={{ width: "100%" }} />
  ) : (
    <Select<string[]>
      optionLabelProp="label"
      optionFilterProp="label"
      defaultValue={selectedValues}
      options={options}
      showSearch
      mode="multiple"
      tagRender={customTagRender}
      maxTagCount="responsive"
      onChange={handleChange}
      maxTagPlaceholder={maxTagRenderer}
      getPopupContainer={(node) => {
        return node.parentNode as HTMLElement;
      }}
    />
  );
}

function DisputeTitle(props: DisputeDefaultFormElementProps<string, string>) {
  const { value: selectedValue, onChange } = props;

  function handleChange(event: OnInputChange[number]) {
    onChange?.(event.target.value);
  }
  return <Input defaultValue={selectedValue} onChange={handleChange} />;
}

function DisputeDescription(
  props: DisputeDefaultFormElementProps<string, string>
) {
  const { value: selectedValue, onChange } = props;
  function handleChange(event: OnTextAreaChange[number]) {
    onChange?.(event.target.value);
  }
  return <TextArea onChange={handleChange} defaultValue={selectedValue} />;
}

export { DisputeDescription, DisputeTitle, DisputeTypesForm };
